module.exports = __webpack_public_path__ + "static/media/globe.251a079f.svg";